module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"cancel":"Abbrechen","newCampaign":"Neue Aktion"},"en":{"cancel":"Cancel","newCampaign":"New campaign"}}')
  delete Component.options._Ctor
}
